import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--edit-working-hours-modal'
    ];

    openModal() {
        showPreloader();

        this.profileEditWorkingHoursModalOutlet.openModal();

        hidePreloader();
    }
}
